'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var webcrypto = require('../webcrypto');

var lengths = require('./lengths');

var hashTypes = {
  SHA1: 'SHA-1',
  SHA256: 'SHA-256',
  SHA512: 'SHA-512'
};

var sign = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, data) {
    var buf;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return webcrypto.get().subtle.sign({
              name: 'HMAC'
            }, key, data);

          case 2:
            buf = _context.sent;
            return _context.abrupt("return", new Uint8Array(buf, buf.byteOffset, buf.byteLength));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sign(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.create = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(hashType, secret) {
    var hash, key;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            hash = hashTypes[hashType];
            _context3.next = 3;
            return webcrypto.get().subtle.importKey('raw', secret, {
              name: 'HMAC',
              hash: {
                name: hash
              }
            }, false, ['sign']);

          case 3:
            key = _context3.sent;
            return _context3.abrupt("return", {
              digest: function digest(data) {
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          return _context2.abrupt("return", sign(key, data));

                        case 1:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }))();
              },
              length: lengths[hashType]
            });

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();